import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useState } from 'react';

import AuthWrapper from 'sections/auth/AuthWrapper';
import { fetchCurrentUser, logoutSession } from 'utils/auth';

export default function PendingApproval({ status }) {
  const isRejected = status === 'rejected';
  const [checking, setChecking] = useState(false);

  const handleLogout = async () => {
    await logoutSession();
    window.location.href = '/login';
  };

  const handleCheckStatus = async () => {
    setChecking(true);
    await fetchCurrentUser();
    window.location.reload();
  };

  return (
    <AuthWrapper>
      <Stack sx={{ gap: 2, alignItems: 'flex-start' }}>
        <Chip
          label={isRejected ? 'Application not approved' : 'Pending approval'}
          color={isRejected ? 'error' : 'warning'}
          size="small"
        />
        <Typography variant="h4">
          {isRejected ? 'Your admin account was not approved' : 'Your account is awaiting approval'}
        </Typography>
        <Typography color="text.secondary">
          {isRejected
            ? 'A super admin reviewed your application and did not approve it. Contact support if you believe this is a mistake.'
            : "Thanks for signing up! A super admin needs to approve your account before you can create and manage a chama. You'll be able to log in normally once approved."}
        </Typography>
        <Stack direction="row" sx={{ gap: 1.5 }}>
          {!isRejected && (
            <Button variant="contained" onClick={handleCheckStatus} disabled={checking}>
              {checking ? 'Checking...' : 'Check status'}
            </Button>
          )}
          <Button variant="outlined" onClick={handleLogout}>
            Log out
          </Button>
        </Stack>
      </Stack>
    </AuthWrapper>
  );
}
